// extracted by mini-css-extract-plugin
module.exports =  {"container":"Tooltip-module__container___pS7Eh","arrow":"Tooltip-module__arrow___a02fP"};